import { useDisclosure } from "@heroui/react";
import React from "react";

import DeleteAccountModal from "@wc/domain/users/components/delete-account-modal";
import UserProfileInfo from "@wc/domain/users/components/user-profile-info";

/**
 * Profile page for viewing and editing user settings
 * @returns {React.ReactElement} The profile page
 */
export default function Profile() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <div className="mx-auto w-full max-w-xl">
      <h1 className="mb-6 text-2xl font-bold">Profile</h1>
      <UserProfileInfo onDeleteClick={onOpen} />
      <DeleteAccountModal isOpen={isOpen} onClose={onClose} />
    </div>
  );
}
